import Parse from '@/parse'
const User = Parse.User
const messages =  {
  new: 'ユーザーを作成しました。',
  update: 'ユーザーを更新しました。'
}

export default {
  initForm ({ state, getters, commit }) {
    commit('setPassword', null)
    commit('setTel', state.user.get('tel'))
    commit('setName', state.user.get('name'))

    const birthDay = getters.splitBirthDay
    commit('setBirthDayYear', birthDay[0])
    commit('setBirthDayMonth', birthDay[1])
    commit('setBirthDayDate', birthDay[2])

    commit('setCountry', state.user.get('country'))
    commit('setPrefecture', state.user.get('prefecture'))
    commit('setAddress', state.user.get('address'))
    commit('setEmail', state.user.get('username'))
    commit('setAdmin', state.user.get('admin'))
  },

  resetForm ({ commit }) {
    commit('setPassword', null)
    commit('setTel', '')
    commit('setName', '')
    commit('setBirthDayYear', 1900)
    commit('setBirthDayMonth', 1)
    commit('setBirthDayDate', 1)
    commit('setCountry', null)
    commit('setPrefecture', null)
    commit('setAddress', '')
    commit('setEmail', null)
    commit('setAdmin', false)
  },

  retrieveUsers ({ commit }) {
    let query = new Parse.Query(User)
    query.descending('createdAt')
    query.include('country', 'prefecture')
    query.find().then((results) => {
      commit('setUsers', results)
    }).catch((error) => {
      console.log(error)
    })
  },

  async getUser({ commit }, id) {
    let query = new Parse.Query(User)
    let user = await query.get(id)
    commit('setUser', user)
  },

  async updateUser ({ state, getters }) {
    let user = state.user

    if (state.password) {
      user.set('password', state.password)
    }

    if (state.email) {
      user.set('email', state.email)
      user.set('username', state.email)
    }
    user.set('tel', state.tel)
    user.set('name', state.name)
    user.set('birthDay', getters.birthDay)
    user.set('country', state.country)
    user.set('prefecture', state.prefecture)
    user.set('address', state.address)
    user.set('admin', state.admin)
    const result = await user.save()
    await Parse.Cloud.run('setAdminACL', { id: result.id })
    await Parse.Cloud.run('setAdminRole', { id: result.id })
    return messages.update
  },

  async createUser({ state, getters, dispatch }) {
    let user = new User()
    if (state.email) {
      user.set('email', state.email)
      user.set('username', state.email)
    }
    user.set('password', state.password)
    user.set('tel', state.tel)
    user.set('name', state.name)
    user.set('birthDay', getters.birthDay)
    user.set('country', state.country)
    user.set('prefecture', state.prefecture)
    user.set('address', state.address)
    user.set('admin', state.admin)

    try {
      if (!state.password) {
        throw new Parse.Error(1002)
      }

      const result = await user.save()
      await Parse.Cloud.run('setAdminACL', { id: result.id })
      await Parse.Cloud.run('setAdminRole', { id: result.id })
      return messages.new
    } catch (error) {
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  },

  deleteUser({ state, commit }) {
    state.user.destroy().then(() => {
      commit(
        'snackBar/addMessage',
        'ユーザーを削除しました。',
        { root: true }
      )
    })
  }
}
